import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {IncidentCreateComponent} from './incident-create/incident-create.component';
import {IncidentDetailComponent} from './incident-detail/incident-detail.component';
import {IncidentEditComponent} from './incident-edit/incident-edit.component';
import {IncidentListComponent} from './incident-list/incident-list.component';
import {IncidentEntityResolver} from './incident-entity.resolver';
import {IncidentDetailedListComponent} from './incident-detailed-list/incident-detailed-list.component';

const routes: Routes = [
  {
    path: '',
    component: IncidentListComponent
  },
  {
    path: 'create',
    component: IncidentCreateComponent
  },
  {
    path: 'list',
    component: IncidentDetailedListComponent
  },
  {
    path: ':incident-id',
    component: IncidentDetailComponent,
    resolve: {
      incident: IncidentEntityResolver
    }
  },
  {
    path: ':incident-id/edit',
    component: IncidentEditComponent,
    resolve: {
      incident: IncidentEntityResolver
    }
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IncidentRoutingModule { }
